import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { apiClient } from "api";
import { useIntl } from "react-intl";
import { AppState } from "store/types";
import { useDispatch, useSelector } from "react-redux";
import SalesViewAndReportsHeader from "./SalesViewAndReportsHeader";
import { SalesReportsProps } from "api/types";
import SalesReportsTable from "components/Table/SalesReportsTable";
import { clearFilters } from "store/table/table.slice";
import { removeAllSellers } from "store/auth/auth.slice";

const SalesAndReports = () => {
  const dispatch = useDispatch();

  const filters = useSelector((state: AppState) => state.table.columnFilters);

  const expanded = useSelector((state: AppState) => state.table.expand);
  const [salesData, setSalesData] = useState<SalesReportsProps[]>([]);
  const [filteredData, setFilteredData] = useState<SalesReportsProps[]>([]);
  const nav = useSelector((state: AppState) => state.auth.nav);

  const getData = async () => {
    return await apiClient.getSalesReportsData();
  };

  const { data, isFetching, refetch } = useQuery("salesReportsData", getData, {
    staleTime: Infinity,
    retry: 1,
    retryDelay: 10000,
  });

  useEffect(() => {
    if (data && data.length) {
      setSalesData(
        data.map((item: SalesReportsProps, id: number) => ({
          ...item,
          seller_name: item.seller.seller_name,
          seller_id: item.seller.sellerId,
          id,
        }))
      );
    }
    if (filters?.length) {
      let arr = Object.keys(
        filters?.reduce((value, index) => ({ ...value, [index]: index }), {})
      );

      const data = salesData.filter((data: any, index: number) => {
        if (
          //@ts-ignore
          arr[1].toLowerCase().includes(salesData[index][arr[0]]?.toLowerCase())
        )
          return data;
      });
      setFilteredData(data);
    } else {
      setFilteredData([]);
    }
  }, [data, filters]);

  // useEffect(() => {
  //   return () => {
  //     dispatch(clearFilters());
  //     dispatch(removeAllSellers());
  //   };
  // }, []);

  return (
    <Box sx={{ margin: !nav ? "0px 20px" : "0px" }}>
      <SalesViewAndReportsHeader />
      <Box
        sx={{
          display: "flex",
          padding: 0,
          alignItems: "baseline",
          flexDirection: "column",
          justifyContent: "end",
        }}
      >
        <Box
          sx={{
            position: "relative",
            borderTop: "5px solid #002B49",
            borderRadius: "8px",
            height: "80vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <SalesReportsTable
            rows={filteredData.length > 0 ? filteredData : salesData}
            isCheckbox={false}
            editableRow={true}
            fetching={isFetching}
            isGrouping={false}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SalesAndReports;
